import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoadTask } from 'src/app/model/task-list/load-task';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import * as moment from 'moment';
import Employee from 'src/app/model/product/employee';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { SnackService } from 'src/app/services/snack.service';
import { EditLoadTaskService, PutRequestBody } from './edit-load-task.service';

@Component({
  selector: 'edit-load-task',
  templateUrl: './edit-load-task.component.html',
  styleUrls: ['./edit-load-task.component.scss']
})
export class EditLoadTaskComponent extends SubscriptionBasedComponent
  implements OnInit {
  @Input()
  task: LoadTask;

  @Input()
  employeeId: number;

  @Input()
  date: moment.Moment;

  @Input()
  employeeChoices: Employee[];

  @Output()
  saveSuccessEvent = new EventEmitter<LoadTask>();

  init: boolean = false;
  saving: boolean = false;

  selectedEmployee: Employee;
  hourBudget: number;
  minuteBudget: number;

  hours = GeneralHelper.hours;
  minutes = GeneralHelper.minutes;

  constructor(
    private snackService: SnackService,
    private editLoadTaskService: EditLoadTaskService
  ) {
    super();
  }

  ngOnInit(): void {
    this.selectedEmployee =
      this.employeeChoices != null
        ? this.employeeChoices.find(e => e.id === this.employeeId)
        : null;
    this.hourBudget =
      this.task.minuteBudget != null
        ? Math.floor(this.task.minuteBudget / 60)
        : null;
    this.minuteBudget =
      this.task.minuteBudget != null ? this.task.minuteBudget % 60 : null;
    this.init = true;
  }

  taskDateChange(event: any): void {
    this.date = event.value;
  }

  startTimeChanged(value: string): void {
    this.task.startTime = value;
  }

  descriptionChanged(value: string): void {
    this.task.description = value;
  }

  compareEntities(o1: any, o2: any): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }

  compareNumbers(n1, n2): boolean {
    return n1 == n2;
  }

  filterSundays(m: moment.Moment): boolean {
    return m.day() !== 0;
  }

  close(): void {
    this.saveSuccessEvent.emit(null);
  }

  saveTask() {
    if (this.date == null) {
      this.snackService.showError('Gelieve een datum te kiezen');
      return;
    }
    if (this.selectedEmployee == null) {
      this.snackService.showError('Gelieve een installateur te kiezen');
      return;
    }
    if (this.hourBudget == null && this.minuteBudget == null) {
      this.snackService.showError('Gelieve een doorlooptijd te specificeren');
      return;
    }

    this.task.minuteBudget =
      (this.hourBudget == null ? 0 : Number(this.hourBudget) * 60) +
      (this.minuteBudget == null ? 0 : Number(this.minuteBudget));

    const requestBody: PutRequestBody = {
      task: this.task,
      date: this.date,
      employeeId: this.selectedEmployee.id
    };

    this.saving = true;

    this.editLoadTaskService
      .update(requestBody)
      .then(res => {
        this.saveSuccessEvent.emit(res);
        this.snackService.showSuccess('Laadmoment succesvol opgeslagen');
      })
      .finally(() => (this.saving = false));
  }
}
